import NumericFunction from "../../../utils/NumericFunction";

const PrintType7Header2 = ({ date, name, company }) => {
  return (
    <div className={""}>
      <div className={"d-flex flex-wrap w-100 headerPrintType7 text-center"}>
        <div
          style={{ flex: "80%" }}
          className={"d-flex justify-content-between flex-wrap w-100 text-end"}
        >
          <div></div>
          <div className="center">
            <div>{name}</div>
            <div>{company}</div>
          </div>
          <div>{date}</div>
        </div>
      </div>
    </div>
  );
};

export default PrintType7Header2;
